import { Route, Routes } from "react-router-dom";
import UsersChat from "../pages/dashboardPage/customerService/usersChat/UsersChat";
import PrizeDelivery from "../pages/dashboardPage/customerService/prizeDelivery/PrizeDelivery";

const CustomerServiceNavigator = () => {
  return (
    <Routes>
      <Route path="/show-users-chats" element={<UsersChat />} />
      <Route path="/show-prize-Delivery" element={<PrizeDelivery />} />
      <Route path="*" element={<UsersChat />} />
    </Routes>
  );
};

export default CustomerServiceNavigator;
